import { ref } from 'vue';

const isSupportOverlayOpen = ref(false);

export const useSupport = () => {
    const openSupportOverlay = () => {
        isSupportOverlayOpen.value = true;
    };

    const closeSupportOverlay = () => {
        isSupportOverlayOpen.value = false;
    };

    const handleSupportLinkClick = (event: Event) => {
        const target = event.target as HTMLElement;
        if (target.tagName === 'A') {
            event.preventDefault();
            openSupportOverlay();
        }
    };

    return {
        isSupportOverlayOpen,
        openSupportOverlay,
        closeSupportOverlay,
        handleSupportLinkClick,
    };
};
